import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useLocation, NavLink } from 'react-router-dom';
import './AdminLayout.css';

const addMenuItems = [
  { to: '/admin/car-models', icon: 'fa-layer-group', label: 'إضافة موديل' },
  { to: '/admin/car-variants', icon: 'fa-car', label: 'إضافة سيارة' },
  { to: '/admin/spare-parts?category=accessories', icon: 'fa-star', label: 'إضافة كماليات' },
  { to: '/admin/spare-parts', icon: 'fa-cogs', label: 'إضافة قطعة غيار' },
  { to: '/admin/settings', icon: 'fa-cog', label: 'الإعدادات' },
];

const AdminLayout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [addMenuOpen, setAddMenuOpen] = useState(false);
  const addMenuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (addMenuRef.current && !addMenuRef.current.contains(e.target)) {
        setAddMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_user');
    window.location.href = '/admin/login';
  };

  const closeSidebar = () => setSidebarOpen(false);
  const toggleSidebar = () => setSidebarOpen((prev) => !prev);

  const navItems = [
    { to: '/admin/dashboard', icon: 'fa-chart-line', label: 'لوحة التحكم' },
    { to: '/admin/orders', icon: 'fa-shopping-bag', label: 'الطلبات' },
    { to: '/admin/analytics', icon: 'fa-chart-pie', label: 'إحصائيات الزيارات' },
    { to: '/admin/car-models', icon: 'fa-layer-group', label: 'الموديلات' },
    { to: '/admin/car-variants', icon: 'fa-car', label: 'السيارات' },
    { to: '/admin/spare-parts?category=accessories', icon: 'fa-star', label: 'كماليات', isActive: (_, loc) => loc && loc.pathname === '/admin/spare-parts' && (loc.search || '').includes('category=accessories') },
    { to: '/admin/spare-parts', icon: 'fa-cogs', label: 'قطع الغيار', isActive: (_, loc) => loc && loc.pathname === '/admin/spare-parts' && !(loc.search || '').includes('category=accessories') },
    { to: '/admin/settings', icon: 'fa-cog', label: 'الإعدادات' },
  ];

  return (
    <div className="admin-dashboard-layout">
      <button
        type="button"
        className={`admin-sidebar-toggle ${sidebarOpen ? 'admin-sidebar-toggle--open' : ''}`}
        onClick={toggleSidebar}
        aria-label={sidebarOpen ? 'إغلاق القائمة' : 'القائمة'}
        aria-expanded={sidebarOpen}
      >
        <i className={`fas ${sidebarOpen ? 'fa-times' : 'fa-bars'}`} aria-hidden="true" />
      </button>
      <div
        className={`admin-sidebar-overlay ${sidebarOpen ? 'active' : ''}`}
        onClick={closeSidebar}
        aria-hidden="true"
      />
      <aside className={`admin-sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div className="admin-sidebar-header">
          <div className="admin-sidebar-logo">
            <div className="admin-sidebar-logo-icon">
              <i className="fas fa-car-side" />
            </div>
            <h2 className="admin-sidebar-title">حمزة لقطع غيار مرسيدس</h2>
          </div>
        </div>
        <nav className="admin-sidebar-nav">
          {navItems.map((item) => (
            <NavLink
              key={item.label}
              to={item.to}
              className={({ isActive }) => {
                const active = item.isActive ? item.isActive({}, location) : isActive;
                return `admin-nav-item ${active ? 'active' : ''}`;
              }}
              onClick={closeSidebar}
            >
              <i className={`fas ${item.icon}`} />
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="admin-sidebar-footer">
          <button
            type="button"
            className="admin-sidebar-logout"
            onClick={handleLogout}
          >
            <i className="fas fa-sign-out-alt" />
            <span>تسجيل الخروج</span>
          </button>
        </div>
      </aside>
      <div className="admin-main-content">
        <header className="admin-topbar">
          <h1 className="admin-topbar-title">لوحة تحكم المدير</h1>
          <div className="admin-topbar-actions">
            <div className="admin-add-menu" ref={addMenuRef}>
              <button
                type="button"
                className="admin-topbar-add-btn"
                onClick={() => setAddMenuOpen((v) => !v)}
                aria-label="إضافة"
                aria-expanded={addMenuOpen}
              >
                <i className="fas fa-plus" />
              </button>
              {addMenuOpen && (
                <div className="admin-add-dropdown">
                  {addMenuItems.map((item) => (
                    <button
                      key={item.label}
                      type="button"
                      className="admin-add-dropdown-item"
                      onClick={() => {
                        const openForm = item.to !== '/admin/settings';
                        navigate(item.to, { state: openForm ? { openAddForm: true } : undefined });
                        setAddMenuOpen(false);
                      }}
                    >
                      <i className={`fas ${item.icon}`} />
                      <span>{item.label}</span>
                    </button>
                  ))}
                </div>
              )}
            </div>
            <button
              type="button"
              className="admin-topbar-btn"
              onClick={() => navigate('/')}
              aria-label="الموقع الرئيسي"
            >
              <i className="fas fa-home" aria-hidden="true" />
              <span>الموقع الرئيسي</span>
            </button>
          </div>
        </header>
        <div className="admin-content-area">
          {children}
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;
